var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[(_vm.$can('read_all-users'))?_c('div',{staticClass:"col-12"},[_c('b-col',{staticClass:"px-0"},[_c('search-by-skill')],1)],1):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }